import { render, staticRenderFns } from "./PredictionResult.vue?vue&type=template&id=6e317248&scoped=true"
import script from "./PredictionResult.vue?vue&type=script&lang=js"
export * from "./PredictionResult.vue?vue&type=script&lang=js"
import style0 from "./PredictionResult.vue?vue&type=style&index=0&id=6e317248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e317248",
  null
  
)

export default component.exports